import { useTranslation } from "react-i18next";

import { useEventMaterials } from "../../hooks/useEventMaterials";
import { InfestationPest } from "../../types/infestation";
import { formatServiceData } from "../../utils/formatServiseData";
import { CustomSlider } from "../CustomSlider/CustomSlider";
import { CustomTextArea } from "../CustomTextArea/CustomTextArea";
import { MaterialsList } from "../MaterialsList/MaterialsList";
import NoProductDocumentsModal from "../Modal/NoProductDocumentsModal";
import { ResourceImages } from "../ResourceImages/ResourceImages";

import styles from "./infestation-details.module.css";

interface Props {
  event: any;
  infestations: InfestationPest[] | undefined;
}

export const InfestationDetails = ({ event, infestations }: Props) => {
  const { t } = useTranslation();
  const { images } = formatServiceData(event);
  const products = useEventMaterials(event);

  return (
    <div>
      <NoProductDocumentsModal />

      {event?.data.infestation === "baitEaten" && (
        <div className={styles["slider"]}>
          <span>{t("PercentageOfBaitEaten")}</span>
          <div className={styles["custom-slider"]}>
            <CustomSlider
              value={event?.data.eatenQuantity ?? 0}
              setValue={() => {}}
            />
          </div>
        </div>
      )}

      <div className={`${styles["services__issue-type__infestation"]}`}>
        <p className={`${styles["issue-type__infestation-title"]}`}>
          {t("InfestationType")}
        </p>
        {infestations?.map((infestation: InfestationPest) => (
          <p className={`${styles["issue-type__infestation-item"]}`}>
            <span>{infestation.name}</span>
            <span>{infestation.pivot?.quantity}</span>
          </p>
        ))}
      </div>

      {products.length > 0 ? (
        <div className={styles.materials}>
          <MaterialsList title={t("Materials")} data={products} readOnly />
        </div>
      ) : null}

      <ResourceImages images={images} />

      <CustomTextArea
        placeholder={t("AdditionalText")}
        defaultValue={event?.data?.comment ?? ""}
        onTextareaChange={() => {}}
        readonly
      />
    </div>
  );
};
